export const departments = [
  {value:"All",label:"All"},
  { value: "coreprograms", label: "Core Programs" },
  { value: "data&Impact", label: "Data & Impact" },
  { value: "medhavi", label: "Medhavi" },
  { value: "systemadoption", label: "System Adoption" },
  { value: "admin", label: "Admin" },
  { value: "technology", label: "Technology" },
  { value: "partnerships", label: "Partnerships" },
  { value: "marcom", label: "MarCom" },
  { value: "finance", label: "Finance" },
  { value: "management", label: "Management" },
  { value: "people", label: "People" },
  { value: "operations", label: "Operations" },
];


